import { useContext } from 'react';
import LanguageContext from '../context/language.context';

export default function SkipToContent() {
  const { language } = useContext(LanguageContext);
  return (
    <a href="#home" className="skip-link">
      {language === 'pt' ? 'Pular para o conteúdo' : 'Skip to content'}
    </a>
  );
}
